export default __webpack_public_path__ + "75400f069595b41e88ac700507811970.woff";